import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import environment from '@environments/environment';
import { EmptyInterface } from '@interfaces/core/model.interface';
import { HttpClientFetcher } from '@services/htttp-client-fetcher.service';
import { ApiHttpConfig } from '@shared/config/api-http.config';
import { lastValueFrom } from 'rxjs';

import { UserResponseDTO } from '../interfaces/user-response-dto.interface';

const { apiUsersUrl } = environment;

@Injectable()
export class AsyncUserFinderFetcher extends HttpClientFetcher<
  UserResponseDTO,
  EmptyInterface
> {
  public async run(
    accessToken: string,
  ): Promise<HttpResponse<UserResponseDTO>> {
    const options = ApiHttpConfig.createWithBearer(accessToken);
    const url = `${apiUsersUrl}/users/islogged`;

    return lastValueFrom(this.findOne(url, options));
  }
}
